import {I18n} from '@aws-amplify/core';
import {Product,} from '../types';
import {PlatformPropertyCard, PlatformPropertyCardEntryInput} from "@flexinet/ui-components";
import {CreatedByProfileFormatter, UserProfile} from "../../../components/CreatedByProfileFormatter.tsx";


// ⚠️ Typed PlatformPropertyCardEntryInput[], never left to inference (§13). Untyped, the
// timestamps carried `formatAs: 'Timestamp'`, a key the card does not read, so Created
// and Last Updated rendered as raw ISO strings and tsc could not see it. Typed, a wrong
// key is a compile error.
export const MetadataPropertyCard = ({record}: { record: Product }) => {

    const properties: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('Created By'),
            value: <CreatedByProfileFormatter record={record as unknown as UserProfile}/>,
            span: 12,
        },
        {
            label: I18n.get('Created'),
            value: record.created,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 12,
        },
        {
            label: I18n.get('Last Updated'),
            value: record.updated,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 12,
        }];


    return (
        <PlatformPropertyCard properties={properties}/>
    );


};
